<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">
        <Input clearable placeholder="输入关键字搜索" class="search-input" v-model="keyword" />

        <label class="search-label">开始时间</label>
          <Date-picker
            :value="startTime"
            @on-change="startTime = $event"
            type="datetime"
            placeholder="选择开始时间"
            style="width: 170px"
          ></Date-picker>
          <label class="search-label">结束时间</label>
          <Date-picker
            :value="endTime"
            @on-change="endTime = $event"
            type="datetime"
            placeholder="选择结束时间"
            style="width: 170px"
          ></Date-picker>

        <label class="search-label">状态</label>
        <Select v-model="status" class="search-input" clearable>
          <Option v-for="item in statusIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">工作类型</label>
        <Select v-model="work_type_id" class="search-input" clearable>
          <Option v-for="item in workTypeIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">平台</label>
        <Select v-model="live_id" class="search-input" @on-change="liveChange" clearable>
          <Option v-for="item in liveIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">视频分类</label>
        <Select v-model="video_classify_id" class="search-input" @on-change="videoClassifyChange" clearable>
          <Option v-for="item in videoClassifyIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">执行账号</label>
        <Select v-model="user_id" class="search-input" clearable filterable>
          <Option v-for="item in userIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <Button @click="handleButtonSearch" class="search-btn" type="primary" style="margin-left: 20px;">搜索</Button>

        <Button @click="showPublishModal" type="primary" style="margin-left: 50px;">发布视频</Button>

        <!-- <Button @click="handleDelete" type="error" style="margin-left: 50px;">删除</Button> -->

        <label >浏览:{{ allSee }}</label>
        <label >点赞:{{ allLike }}</label>
        <label >评论:{{ allComment }}</label>

        </Col>
      </Row>
      <tables editable :columns="columns" v-model="tableData" :loading="tableLoading" @on-selection-change="changeId" />
      <Row class="page-con">
        <div class="page-bottom">
          <Page :current="page" :total="total" :page-size="pageSize" :page-size-opts="[10, 20, 30, 40, 100]" show-sizer show-elevator @on-change="changePage"
            @on-page-size-change="changePageSize" />
        </div>
      </Row>
    </Card>

    <Modal :mask-closable="false" v-model="editModal" title="编辑发布信息" footer-hide>
      <forms :resetFlag="resetFlag" ref="editpushVideo" @on-ok="editSumit" @on-cancel="cancel" />
    </Modal>

    <!-- 发布视频Modal -->
    <Modal
      v-model="publishModal"
      title="发布视频"
      :mask-closable="false"
      :width="800"
      footer-hide
    >
      <Form :model="publishForm" :label-width="120" :rules="publishRules" ref="publishForm">
        <FormItem label="执行账号" prop="dy_user_id">
          <Select
            v-model="publishForm.dy_user_id"
            placeholder="请选择执行账号"
            filterable
            :loading="publishUserListLoading"
          >
            <Option v-for="user in publishUserList" :value="user.id" :key="user.id">
              {{ user.username }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="上传视频" prop="video_download_url">
          <div>
            <input
              type="file"
              accept="video/*"
              @change="handleVideoFileChange"
              ref="videoFileInput"
              style="display: none;"
            />
            <Button @click="$refs.videoFileInput.click()" :loading="videoUploading">
              {{ videoUploading ? '上传中...' : (publishForm.video_download_url ? '重新上传' : '选择视频') }}
            </Button>
            <span v-if="publishForm.video_download_url" style="margin-left: 10px; color: #19be6b;">
              视频已上传
            </span>
          </div>
        </FormItem>
        <FormItem label="视频标题" prop="video_title">
          <Input v-model="publishForm.video_title" placeholder="请输入视频标题" />
        </FormItem>
        <FormItem label="视频描述" prop="video_desc">
          <Input
            v-model="publishForm.video_desc"
            type="textarea"
            :rows="4"
            placeholder="请输入视频描述"
          />
        </FormItem>
        <FormItem label="热门标签">
          <Select
            v-model="publishForm.hot"
            placeholder="请选择热门标签（可选，可多选）"
            filterable
            clearable
            multiple
          >
            <Option v-for="tag in hashtagList" :value="tag.tag" :key="tag.id">
              {{ tag.tag }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="发布类型" prop="publish_type">
          <RadioGroup v-model="publishForm.publish_type">
            <Radio :label="0">立即发布</Radio>
            <Radio :label="1">定时发布</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          v-if="publishForm.publish_type === 1"
          label="定时发布时间"
          prop="scheduled_time"
        >
          <DatePicker
            v-model="publishForm.scheduled_time"
            type="datetime"
            placeholder="选择发布时间"
            style="width: 100%;"
            :options="datePickerOptions"
          />
        </FormItem>
        <FormItem>
          <div style="text-align: right;">
            <Button @click="cancelPublish" style="margin-right: 10px;">取消</Button>
            <Button type="primary" @click="handlePublishVideo" :loading="publishLoading">确认</Button>
          </div>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
import Tables from '_c/tables/table-only.vue'
import Forms from './push_video_form.vue'

import { getTimeDifference, uploadFile } from '@/api/uploadOss'

import { videoList, editPushVideo, getShortVideoWorkTypeList, getShortVideoClassify,
  getLiveType, getStrategyUser, finishVideo, endPushVideo, okPushVideo, pushVideo, hashtag_list } from '@/api/data'
import moment from 'moment'
const { v4: uuidv4 } = require('uuid')
export default {
  name: 'finance',
  components: {
    Tables,
    Forms
  },
  data () {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      statusIds: [{ id: -1, name: '全部' }, { id: 0, name: '未发布' }, { id: 1, name: '已发布' }, { id: 5, name: '任务终止' }],
      startTime: '',
      endTime: '',
      user_id: '',
      keyword: '',
      userIds: [],
      liveIds: [],
      workTypeIds: [],
      videoClassifyIds: [],
      allSee: 0,
      allLike: 0,
      allComment: 0,
      live_id: '',
      work_type_id: '',
      video_classify_id: '',
      status: -1,
      classifyId: 0,
      liveId: 0,
      userId: 0,
      // 发布视频相关
      publishModal: false,
      publishUserList: [],
      publishUserListLoading: false,
      videoUploading: false,
      hashtagList: [],
      publishLoading: false,
      publishForm: {
        dy_user_id: null,
        video_download_url: '',
        video_title: '',
        video_desc: '',
        hot: [], // 改为数组，支持多选
        _save: false,
        see_permission: 0,
        publish_type: 0, // 0=立即发布, 1=定时发布
        scheduled_time: '',
        timezone: ''
      },
      publishRules: {
        dy_user_id: [
          {
            required: true,
            message: '请选择执行账号',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('请选择执行账号'))
              } else {
                callback()
              }
            }
          }
        ],
        video_download_url: [
          { required: true, message: '请上传视频', trigger: 'change' }
        ],
        video_title: [
          { required: true, message: '请输入视频标题', trigger: 'blur' }
        ],
        scheduled_time: [
          {
            required: true,
            message: '请选择定时发布时间',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (this.publishForm.publish_type === 1 && !value) {
                callback(new Error('请选择定时发布时间'))
              } else {
                callback()
              }
            }
          }
        ]
      },
      datePickerOptions: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000 // 不能选择今天之前的日期
        }
      },
      columns: [
        {
          type: 'index',
          title: '序号',
          width: 100,
          align: 'center'
        },
        {
          title: '执行账号',
          key: 'nickname',
          editable: true,
          align: 'center',
          render: (h, params) => {
            let texts = params.row.username
            if (texts == null || texts == '') {
              texts = params.row.advertisementVideo.mergeVideo.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.nickname
            }
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          }
        },
        { title: '平台', key: 'live', editable: true, align: 'center' },
        { title: '浏览', key: 'see_count', editable: true, align: 'center' },
        { title: '点赞', key: 'like_count', editable: true, align: 'center' },
        { title: '评论', key: 'comment_count', editable: true, align: 'center' },
        // { title: "分享", key: "share_count", editable: true, align: "center" },
        // {
        //   title: "发布时间",
        //   key: "status",
        //   width: 100, align: "center",
        //   render: (h, params) => {
        //     var texts = "立即发布"
        //     if (params.row.advertisementVideo.mergeVideo.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.push_date) {
        //       texts = params.row.advertisementVideo.mergeVideo.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.push_date
        //     }
        //     return h(
        //       "div",
        //       {
        //         props: {}
        //       },
        //       texts
        //     );
        //   },
        // },
        {
          title: '视频标题',
          key: 'video_title',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              // 显示的位置上方
              h('Tooltip', {
                props: { placement: 'top', transfer: true }
              }, [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '70px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }
                }, params.row.video_title),
                // 显示的内容
                h('span', {
                  slot: 'content',
                  style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                }, params.row.video_title)
              ])
            ])
          }
        },
        // {
        //   title: "视频描述", key: "video_desc", editable: true, align: "center", render: (h, params) => {
        //     return h('div', [
        //       // 显示的位置上方
        //       h('Tooltip', {
        //         props: { placement: 'top', transfer: true }
        //       }, [
        //         h('span', {
        //           style: {
        //             display: 'inline-block',
        //             width: '70px',
        //             overflow: 'hidden',
        //             textOverflow: 'ellipsis',
        //             whiteSpace: 'nowrap',
        //           },
        //         }, params.row.video_desc),
        //         // 显示的内容
        //         h('span', {
        //           slot: 'content',
        //           style: { whiteSpace: 'normal', wordBreak: 'break-all' }
        //         }, params.row.video_desc)
        //       ])
        //     ])
        //   }
        // },
        {
          title: '视频',
          key: 'srt_path',
          editable: true,
          align: 'center',
          render: (h, params) => {
            var url = ''
            if (params.row.advertisementVideo.video_path == null || params.row.advertisementVideo.video_path == '') {
              if (params.row.advertisementVideo.mergeVideo.output_video_path == null || params.row.advertisementVideo.mergeVideo.output_video_path == '') {
                if (params.row.advertisementVideo.mergeVideo.covertFace.output_video_path == null || params.row.advertisementVideo.mergeVideo.covertFace.output_video_path == '') {
                  url = params.row.advertisementVideo.mergeVideo.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.url
                } else {
                  url = params.row.advertisementVideo.mergeVideo.covertFace.output_video_path
                }
              } else {
                url = params.row.advertisementVideo.mergeVideo.output_video_path
              }
            } else {
              url = params.row.advertisementVideo.video_path
            }
            return url && url.length > 0 != '' ? h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.download(url)
                    }
                  }
                },
                '下载'
              )
            ]) : h('span', '')
          }
        },
        {
          title: '发布后地址',
          key: 'srt_path',
          editable: true,
          align: 'center',
          render: (h, params) => {
            return params.row.video_url && params.row.video_url.length > 0 != '' ? h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.download(params.row.video_url)
                    }
                  }
                },
                '查看'
              )
            ]) : h('span', '')
          }
        },
        {
          title: '状态',
          key: 'status',
          align: 'center',
          editable: true,
          render: (h, params) => {
            let status = params.row.status
            var texts = '已发布'
            if (status == 0) {
              texts = '未确认'
            } else if (status == 1) {
              texts = '已发布'
            } else if (status == 2) {
              texts = '已确认'
            } else if (status == 5) {
              texts = '任务终止'
            }

            var color = '#515a6e'
            if (params.row.status == 0) {
              color = '#ff0000'
            } else if (params.row.status == 2) {
              color = '#03A9F4'
            }

            return h(
              'div',
              {
                props: {},
                style: {
                  color: color
                }
              },
              texts
            )
          }
        },
        { title: '创建时间',
          key: 'create_time',
          editable: true,
          align: 'center',
          render: (h, params) => {
            let texts = getTimeDifference(params.row.create_time)
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          } },
        { title: '更新时间',
          key: 'update_time',
          editable: true,
          align: 'center',
          render: (h, params) => {
            let texts = getTimeDifference(params.row.update_time)
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          } },
        { title: '发布时间',
          key: 'push_date',
          editable: true,
          align: 'center',
          render: (h, params) => {
            let texts = getTimeDifference(params.row.push_date)
            return h(
              'div',
              {
                props: {}
              },
              texts
            )
          } },
        {
          title: 'Handle',
          key: 'handle',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              params.row.status == 1 ? h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.resetPushVideo(params)
                    }
                  }
                },
                '重新发布'
              ) : h('span', ''),
              params.row.status == 2 ? h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.pushVideo(params)
                    }
                  }
                },
                '完成发布'
              ) : h('span', ''),
              // params.row.status == 0 ? h(
              //   "Button",
              //   {
              //     props: {
              //       type: "info",
              //       size: "small",
              //     },
              //     style: {
              //       marginRight: "5px",
              //     },
              //     on: {
              //       click: () => {
              //         this.okVideo(params);
              //       },
              //     },
              //   },
              //   "可以发布"
              // ) : h('span', ''),
              h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params)
                    }
                  }
                },
                '编辑'
              )
            ])
          }
        }
      ],
      tableData: []
    }
  },
  watch: {
    '$route': function (to, from) {
      // 路由发生变化时，重新获取数据
      this.handleSearch()
    }
  },
  methods: {
    // getTimeDifference(originalTime) {

    //   if (originalTime == null || originalTime == '')
    //     return ""

    //   originalTime = new Date(originalTime.replace(/-/g, '/'));
    //   const now = new Date();
    //   const differenceInMs = now - originalTime;
    //   const differenceInMinutes = Math.floor(differenceInMs / (1000 * 60));
    //   const differenceInHours = Math.floor(differenceInMinutes / 60);
    //   const differenceInDays = Math.floor(differenceInHours / 24);

    //   if (differenceInDays > 3) {
    //     // 超过3天，显示原始时间
    //     return `原始时间是: ${originalTime.toLocaleString()}`;
    //   } else if (differenceInDays > 1) {
    //     // 超过1天但不超过3天，显示为“x天前”
    //     return `${differenceInDays}天前`;
    //   } else if (differenceInHours > 1) {
    //     // 超过1小时但不超过1天，显示为“x小时前”
    //     return `${differenceInHours}小时前`;
    //   } else if (differenceInMinutes > 1) {
    //     // 超过1分钟但不超过1小时，显示为“x分钟前”
    //     return `${differenceInMinutes}分钟前`;
    //   } else {
    //     // 少于1分钟，显示为“刚刚”
    //     return '刚刚';
    //   }
    // },
    okVideo (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认该视频可以发布</p>',
        onOk: () => {
          okPushVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    handleButtonSearch () {
      this.page = 1
      this.handleSearch()
    },
    handleEnd (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认终止任务？</p>',
        onOk: () => {
          endPushVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    download (url) {
      window.open(url, '_blank')
    },
    resetPushVideo (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认该视频重新发布</p>',
        onOk: () => {
          okPushVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    pushVideo (params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认完成发布？</p>',
        onOk: () => {
          let data = new FormData()
          finishVideo(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success('成功!')
              } else {
                this.$Message.error(res.data.msg)
              }
            }).catch((err) => {
              this.$Message.error('失败!')
            })
        },
        onCancel: () => {
          this.$Message.info('已取消')
        }
      })
    },
    liveTypeChange (value) {
      if (value == undefined) {
        return
      }
      var params = {
        live_id: value
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          data[i] = { id: users[i].dy_id, name: users[i].username }
        }
        this.userIds = data
      })
    },
    showAddModal () {
      this.addModal = true
      this.resetFlag = !this.resetFlag
      this.$refs.pushVideo.setClassifyData(this.classifyIds)
      this.$refs.pushVideo.setLiveTypeData(this.liveIds)
    },
    changeId (selection) {
      this.selectId = []
      for (let i = 0; i < selection.length; i++) {
        this.selectId[i] = selection[i].id
      }
    },
    showEditModal (params) {
      this.editData = params.row
      this.editModal = true
      this.$refs.editpushVideo.setEditData(this.editData)
    },
    editSumit (formValidate) {
      const data = {
        url: formValidate.url
      }
      editPushVideo(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success('成功!')
            this.editModal = false
            this.handleSearch()
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error('失败!')
        })
    },
    cancel () { },
    changePage (page) {
      this.page = page
      this.handleSearch()
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleSearch () {
      this.setTableLoading(true)
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.status,
        live_id: this.live_id,
        keyword: this.keyword,
        user_id: this.user_id,
        work_type: this.work_type_id,
        video_classify: this.video_classify_id,
        startTime: this.startTime,
        endTime: this.endTime
      }
      videoList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list.records
          this.total = res.data.data.list.total
          this.allSee = res.data.data.see
          this.allLike = res.data.data.like
          this.allComment = res.data.data.comment
        } else {
          this.tableData = []
          this.total = 0
        }
        this.setTableLoading(false)
      })
    },
    setTableLoading (state) {
      this.tableLoading = state
    },
    videoClassifyChange (value) {
      this.getStrategyUser()
    },
    liveChange (value) {
      this.getStrategyUser()
    },
    getStrategyUser () {
      var params = {
        short_video_classify: this.video_classify_id,
        live_id: this.live_id
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          var user = users[i]
          data.push({ id: user.id.toString(), name: user.username })
        }
        this.userIds = data
      })
    },
    // 发布视频相关方法
    async showPublishModal () {
      this.publishModal = true
      // 重置表单
      this.publishForm = {
        dy_user_id: null,
        video_download_url: '',
        video_title: '',
        video_desc: '',
        hot: [], // 改为数组
        _save: false,
        see_permission: 0,
        publish_type: 0,
        scheduled_time: '',
        timezone: this.getCurrentTimezone()
      }
      // 加载用户列表和热门标签列表
      await this.loadPublishUserList()
      await this.loadHashtagList()
    },
    async loadPublishUserList () {
      this.publishUserListLoading = true
      try {
        const res = await getStrategyUser({})
        if (res.data.code === 200) {
          this.publishUserList = res.data.data.records || []
          // console.log('用户列表加载成功:', this.publishUserList);
        } else {
          this.$Message.error('加载用户列表失败：' + (res.data.msg || '未知错误'))
        }
      } catch (error) {
        this.$Message.error('加载用户列表失败')
        // console.error('加载用户列表错误:', error);
      } finally {
        this.publishUserListLoading = false
      }
    },
    async loadHashtagList () {
      try {
        const res = await hashtag_list({})
        if (res.data.code === 200) {
          this.hashtagList = res.data.data.records || []
        }
      } catch (error) {
        // console.error('加载热门标签列表失败:', error);
      }
    },
    getCurrentTimezone () {
      // 获取当前时区
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      return timezone || 'Asia/Shanghai'
    },
    async handleVideoFileChange (e) {
      const file = e.target.files[0]
      if (!file) return

      // 检查文件类型
      if (!file.type.startsWith('video/')) {
        this.$Message.error('请选择视频文件')
        return
      }

      this.videoUploading = true
      try {
        // 上传视频到OSS
        const currentDate = moment().format('YYYY-MM-DD')
        const uuid = uuidv4()
        const fileExtension = file.name.substring(file.name.lastIndexOf('.'))
        const path = `short_video/${currentDate}/publish_video/${uuid}${fileExtension}`

        const videoUrl = await uploadFile(path, file)

        if (videoUrl) {
          this.publishForm.video_download_url = videoUrl
          this.$Message.success('视频上传成功')
        } else {
          this.$Message.error('视频上传失败')
        }
      } catch (error) {
        this.$Message.error('视频上传失败：' + (error.message || '网络错误'))
        console.error(error)
      } finally {
        this.videoUploading = false
      }
    },
    handlePublishVideo () {
      this.$refs.publishForm.validate(async (valid) => {
        if (valid) {
          this.publishLoading = true
          try {
            // 构建请求数据
            const requestData = {
              dy_user_id: this.publishForm.dy_user_id,
              video_download_url: this.publishForm.video_download_url,
              video_title: this.publishForm.video_title,
              video_desc: this.publishForm.video_desc || '',
              hot: Array.isArray(this.publishForm.hot) ? this.publishForm.hot.join(',') : (this.publishForm.hot || ''),
              _save: false,
              see_permission: 0,
              publish_type: this.publishForm.publish_type,
              timezone: this.publishForm.timezone
            }

            // 如果是定时发布，添加定时时间
            if (this.publishForm.publish_type === 1) {
              if (!this.publishForm.scheduled_time) {
                this.$Message.error('请选择定时发布时间')
                this.publishLoading = false
                return
              }
              // 格式化时间为 YYYY-MM-DD HH:mm:ss
              requestData.scheduled_time = moment(this.publishForm.scheduled_time).format('YYYY-MM-DD HH:mm:ss')
            }

            const res = await pushVideo(requestData)

            if (res.data.code === 200) {
              this.$Message.success('发布成功！')
              this.publishModal = false
              this.handleSearch() // 刷新列表
            } else {
              this.$Message.error(res.data.msg || '发布失败')
            }
          } catch (error) {
            this.$Message.error('发布失败：' + (error.message || '网络错误'))
            // console.error('发布视频错误:', error);
          } finally {
            this.publishLoading = false
          }
        } else {
          this.$Message.warning('请完善表单信息')
        }
      })
    },
    cancelPublish () {
      this.publishModal = false
      this.publishForm = {
        dy_user_id: null,
        video_download_url: '',
        video_title: '',
        video_desc: '',
        hot: [], // 改为数组
        _save: false,
        see_permission: 0,
        publish_type: 0,
        scheduled_time: '',
        timezone: this.getCurrentTimezone()
      }
      if (this.$refs.videoFileInput) {
        this.$refs.videoFileInput.value = ''
      }
    }
  },
  mounted () {
    this.getStrategyUser()
    this.handleSearch()
    getLiveType({}).then((res) => {
      if (res.data.code == 200) {
        var lives = res.data.data
        var data = new Array()
        for (var i = 0; i < lives.length; i++) {
          data[i] = { id: lives[i].id.toString(), name: lives[i].name }
        }
        this.liveIds = data
      }
    })

    getShortVideoWorkTypeList().then((res) => {
      var workType = res.data.data.records
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.workTypeIds = data
    })

    getShortVideoClassify({}).then((res) => {
      var workType = res.data.data.records
      var data = new Array()
      for (var i = 0; i < workType.length; i++) {
        data[i] = { id: workType[i].id.toString(), name: workType[i].name }
      }
      this.videoClassifyIds = data
    })
  }
}
</script>
